import { render, staticRenderFns } from "./TopNewsDetailPageV2.vue?vue&type=template&id=28d61021&scoped=true"
import script from "./TopNewsDetailPageV2.vue?vue&type=script&lang=js"
export * from "./TopNewsDetailPageV2.vue?vue&type=script&lang=js"
import style0 from "./TopNewsDetailPageV2.vue?vue&type=style&index=0&id=28d61021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d61021",
  null
  
)

export default component.exports